import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, isDevMode} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';

import {ErrorsService} from 'frontend/services/errors_service';

/**
 * A global error component that displays a user-friendly message
 * and developer details if in dev mode.
 */
@Component({
  selector: 'tap-global-error',
  templateUrl: './global_error.ng.html',
  styleUrl: './global_error.scss',
  imports: [MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalErrorComponent {
  private readonly errorsService = inject(ErrorsService);
  private readonly document = inject(DOCUMENT);
  readonly error = this.errorsService.criticalError;
  protected readonly isDevMode = isDevMode();

  refreshPage() {
    this.document.defaultView?.location.reload();
  }
}
